/* Christina Bundle Progress JS (T29 — 2026-05-05)
   Aktualizuje widget .cb-bundle-progress oraz badge w promo barze
   po kazdej zmianie cart.item_count.

   Sluchacze:
   - Pixel Union Sense events: 'cart:refresh', 'cart:updated', 'on:cart:after-merge'
   - Fetch intercept: /cart/(add|change|update|clear)(.js)?
   - Custom events: 'cb:cart-count-changed' (mozna emitowac z innych miejsc)
*/
(function(){
  'use strict';

  var TIERS = [
    { qty: 2, pct: 30 },
    { qty: 3, pct: 55 },
    { qty: 4, pct: 80 },
    { qty: 5, pct: 99 }
  ];

  function plural(n, one, few, many){
    // Polish plural rules: n=1 -> one; n in 2..4 (mod10, except 12..14) -> few; else many
    var nMod10 = n % 10;
    var nMod100 = n % 100;
    if(n === 1) return one;
    if(nMod10 >= 2 && nMod10 <= 4 && (nMod100 < 10 || nMod100 >= 20)) return few;
    return many;
  }

  function getCartItemCount(){
    // Try internal cache first
    if(typeof window.cb_current_cart_count === 'number') return window.cb_current_cart_count;
    // Fallback: read from cart-count element if present
    var el = document.querySelector('cart-count, [data-cart-count]');
    if(el){
      var t = (el.textContent || '').trim();
      var n = parseInt(t, 10);
      if(!isNaN(n)) return n;
    }
    return 0;
  }

  function setCartItemCount(n){
    window.cb_current_cart_count = n;
  }

  function pickTier(count){
    // Returns {index: 0-3 or -1, current: tier obj or null, next: tier obj or null}
    var current = null;
    var currentIdx = -1;
    for(var i = TIERS.length - 1; i >= 0; i--){
      if(count >= TIERS[i].qty){
        current = TIERS[i];
        currentIdx = i;
        break;
      }
    }
    var next = null;
    for(var j = 0; j < TIERS.length; j++){
      if(count < TIERS[j].qty){
        next = TIERS[j];
        break;
      }
    }
    return { index: currentIdx, current: current, next: next };
  }

  /* BUGS-A / BUG-04 (2026-08-05) — jezyk Rytualu + i18n PL / EN / zh-TW.
     Wczesniej JS byl PL-only i mowil o "znizce"; teraz teksty ida z tabeli
     wybieranej po <html lang>, spojnie ze snippets/christina-bundle-progress.liquid. */
  var CBP_I18N = {
    pl: {
      add2:  'Dodaj <b>2 produkty</b> i otrzymaj <b>−30% na najtańszy</b>.',
      next:  function(n, w, p){ return 'Dodaj jeszcze <b>' + n + ' ' + w + '</b> i otrzymaj <b>−' + p + '% na najtańszy</b>.'; },
      max:   function(p){ return 'Maksymalna korzyść aktywna: <b>−' + p + '% na najtańszy produkt</b> w koszyku.'; },
      on:    function(p){ return 'Aktywna korzyść −' + p + '%'; },
      none:  'Brak aktywnej korzyści'
    },
    en: {
      add2:  'Add <b>2 products</b> and get <b>−30% off the cheapest</b>.',
      next:  function(n, w, p){ return 'Add <b>' + n + ' more ' + (n === 1 ? 'product' : 'products') + '</b> and get <b>−' + p + '% off the cheapest</b>.'; },
      max:   function(p){ return 'Maximum benefit active: <b>−' + p + '% off the cheapest product</b> in the cart.'; },
      on:    function(p){ return 'Active benefit −' + p + '%'; },
      none:  'No active benefit'
    },
    zh: {
      add2:  '加入 <b>2 件商品</b>，即可享 <b>最低價商品 −30%</b>。',
      next:  function(n, w, p){ return '再加入 <b>' + n + ' 件商品</b>，即可享 <b>最低價商品 −' + p + '%</b>。'; },
      max:   function(p){ return '已達最高優惠：購物車中<b>最低價商品 −' + p + '%</b>。'; },
      on:    function(p){ return '已啟用優惠 −' + p + '%'; },
      none:  '尚未啟用優惠'
    }
  };
  function cbpT(){
    var l = (document.documentElement.getAttribute('lang') || 'pl').toLowerCase().slice(0, 2);
    return CBP_I18N[l] || CBP_I18N.pl;
  }

  function buildMessage(count, info){
    var t = cbpT();
    if(count === 0){
      return t.add2;
    }
    if(info.next){
      var diff = info.next.qty - count;
      var prodWord = plural(diff, 'produkt', 'produkty', 'produktow');
      return t.next(diff, prodWord, info.next.pct);
    }
    // Reached max tier
    return t.max(info.current.pct);
  }

  function buildBadge(count, info){
    var t = cbpT();
    if(info.current){
      return t.on(info.current.pct);
    }
    return t.none;
  }

  function computeProgressPercent(count){
    // Map count to a 0–100% scale where:
    //   0 -> 0%, 2 -> 25%, 3 -> 50%, 4 -> 75%, 5+ -> 100%
    if(count <= 0) return 0;
    if(count === 1) return 12;
    if(count >= 5) return 100;
    // 2 -> 25, 3 -> 50, 4 -> 75
    return (count - 1) * 25;
  }

  function updateWidget(count){
    var widget = document.querySelector('.cb-bundle-progress');
    if(!widget) return;

    var info = pickTier(count);
    widget.setAttribute('data-cb-count', String(count));
    widget.setAttribute('data-cb-tier', String(info.index + 1)); // 0 if no tier

    // Message
    var msgEl = widget.querySelector('.cb-bundle-progress__msg');
    if(msgEl) msgEl.innerHTML = buildMessage(count, info);

    // Badge
    var badgeEl = widget.querySelector('.cb-bundle-progress__badge');
    if(badgeEl) badgeEl.textContent = buildBadge(count, info);

    // Bar fill
    var fillEl = widget.querySelector('.cb-bundle-progress__bar-fill');
    if(fillEl) fillEl.style.width = computeProgressPercent(count) + '%';

    // Markers
    var markers = widget.querySelectorAll('.cb-bundle-progress__marker');
    markers.forEach(function(m){
      var mq = parseInt(m.getAttribute('data-cb-qty'), 10);
      m.setAttribute('data-cb-reached', count >= mq ? '1' : '0');
      // active = highest reached marker
      var isActive = info.current && info.current.qty === mq;
      m.setAttribute('data-cb-active', isActive ? '1' : '0');
    });
  }

  function fetchCartCount(){
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        if(d && typeof d.item_count === 'number'){
          setCartItemCount(d.item_count);
          updateWidget(d.item_count);
          return d.item_count;
        }
        return null;
      })
      .catch(function(){ return null; });
  }

  function init(){
    var initial = (typeof window.cb_initial_cart_count === 'number') ? window.cb_initial_cart_count : getCartItemCount();
    setCartItemCount(initial);
    updateWidget(initial);
  }

  // Listen to theme cart events
  ['cart:refresh', 'cart:updated', 'on:cart:after-merge', 'cb:cart-count-changed'].forEach(function(evt){
    document.addEventListener(evt, function(){ fetchCartCount(); });
  });

  // Intercept fetch to /cart/(add|change|update|clear)
  var origFetch = window.fetch;
  if(typeof origFetch === 'function'){
    window.fetch = function(input, opts){
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if(/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)){
        p.then(function(){
          // tiny delay to let theme settle, then re-fetch
          setTimeout(fetchCartCount, 100);
        }).catch(function(){});
      }
      return p;
    };
  }

  // Initial pass — both DOMContentLoaded and after a short delay
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also re-init when cart drawer opens (Sense theme uses dialog/details patterns)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:open', init);
})();
